import {Component, Injector, ViewChild} from '@angular/core';
import {BaseComponent} from "../../base/base.component";
import {TableComponent} from "../../ui/table/table.component";
import {NgxSmartModalService} from "ngx-smart-modal";
import {ShopService} from "../../../services/shop/shop.service";
import {ActivatedRoute} from "@angular/router";
import {ProductSize} from "../../../models/shop/ProductSize";
import {Product} from "../../../models/shop/product";
import Swal from "sweetalert2";

@Component({
  selector: 'app-shop-size',
  templateUrl: './size.component.html',
  styleUrls: ['./size.component.scss']
})
export class SizeComponent extends BaseComponent{
  @ViewChild('sizeList') sizeList: TableComponent | undefined;
  companyId: string = localStorage.getItem('wisper_companyId') ?? '';


  constructor(public serviceInjector: Injector,
              private modal: NgxSmartModalService,
              public shopService: ShopService,
              private router: ActivatedRoute) {
    super(serviceInjector);
  }

  async ngAfterViewInit() {
    this.showSpinner();
    this.sizeList?.loadData(`/productSizes`, {companyId: this.companyId}, ( (item: any) => new ProductSize(item)))
    this.hideSpinner();
  }


  showEditSizeModal(sizeToEdit: Product) {
    this.modal.getModal('editSizeModal').setData(sizeToEdit);
    this.modal.getModal('editSizeModal').open();
  }

  showAddSizeModal() {
    let newSize = new ProductSize();
    this.modal.setModalData(newSize, 'addSizeModal');
    this.modal.getModal('addSizeModal').open();
  }

  async addSize(sizeToAdd: ProductSize) {
    this.spinner.show();

    sizeToAdd['companyId'] = this.companyId;
    console.log(sizeToAdd);
    let response = await this.shopService.addSize(sizeToAdd);
    this.spinner.hide();

    if (response.success){
      Swal.fire({
        icon: 'success',
        title: 'Taglia creata con successo'
      });
      //refresh
      this.sizeList?.reloadPage();
      this.modal.getModal('addSizeModal').close();
    } else {
      Swal.fire({
        icon: 'error',
        title: "Errore durante la creazione del taglia"
      });
    }
  }

  async editSize(sizeToAdd: ProductSize) {
    this.spinner.show();

    console.log(this.companyId)
    sizeToAdd['companyId'] = this.companyId
    let response = await this.shopService.editSize(sizeToAdd.id ?? '', sizeToAdd);

    if (response.success) {
      this.spinner.hide();
      Swal.fire({
        icon: 'success',
        title: 'Taglia modificata con successo'
      });
      //refresh
      this.modal.getModal('editSizeModal').close();
    } else {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: "Errore, riprova a modificare la taglia"
      });
    }
  }

  deleteSize = async (sizeId: string) => {
    const success = (await this.shopService.deleteSize(sizeId)).success;
    if (success) {
      Swal.fire({
        icon: 'success',
        title: 'Taglia eliminata con successo!',
      });
      //refresh
      this.sizeList?.reloadPage();
    } else {
      Swal.fire({
        icon: 'error',
        title: "Errore nell'eliminazione della taglia",
      })
    }
  }

}

